import { ChatTypes } from '../ActionTypes/ChatTypes';

let initialSate = {
    ChatIndexList: [],
    ChatIndexListPagination: null,
    MessageList: [],
    MessageListPagination: null,

};

const ChatReducer = (state = initialSate, action) => {
    switch (action.type) {

        case ChatTypes.GET_CHAT_INDEX:
            let ChatIndexList_Copy = [];
            ChatIndexList_Copy = [
                ...state.ChatIndexList,
                ...action.payload.data,
            ];
            state = {
                ...state,
                ChatIndexListPagination: action.payload,
                ChatIndexList: ChatIndexList_Copy
            };
            break;

        case ChatTypes.CLEAR_CHAT_INDEX:
            state = {
                ...state,
                ChatIndexListPagination: null,
                ChatIndexList: []
            };
            break;

        case ChatTypes.GET_MESSAGE_LIST:
            let MessageList_Copy = [];
            MessageList_Copy = [
                ...state.MessageList,
                ...action.payload.data,
            ];
            state = {
                ...state,
                MessageListPagination: action.payload,
                MessageList: MessageList_Copy
            };
            break;

        case ChatTypes.UPDATE_MESSAGE_LIST:
            let UpdateMessageList_Copy = [...state.MessageList]
            UpdateMessageList_Copy.unshift(action.payload)
            state = {
                ...state,
                MessageList: UpdateMessageList_Copy
            }
            break;

        case ChatTypes.CLEAR_MESSAGE_LIST:
            state = {
                ...state,
                MessageListPagination: null,
                MessageList: []
            };
            break;
    }
    return state;
};

export default ChatReducer;
